
import { useAuth } from "@/contexts/auth";

/**
 * Hook for role-based permission checks
 */
export const useRoleChecks = () => {
  const { profile } = useAuth();
  
  const isSuperAdmin = (): boolean => {
    return profile?.role === 'super_admin';
  };
  
  const isAdmin = (): boolean => {
    return profile?.role === 'admin' || profile?.role === 'super_admin';
  };
  
  const isCountryAdmin = (): boolean => {
    return profile?.role === 'admin' && !isSuperAdmin();
  };
  
  const isPollster = (): boolean => {
    return profile?.role === 'pollster';
  };
  
  const isVerifiedPollster = (): boolean => {
    return profile?.role === 'pollster' && profile?.verified === true;
  };
  
  const isMedia = (): boolean => {
    return profile?.role === 'media';
  };
  
  const isPublic = (): boolean => {
    return profile?.role === 'public' || !profile?.role;
  };
  
  // Get user role for display purposes
  const userRole = profile?.role || 'public';
  
  // Add hasRole function for backward compatibility
  const hasRole = (requiredRole: string): boolean => {
    const userRole = profile?.role || 'public';
    
    // Role hierarchy check
    const roleHierarchy = {
      'super_admin': 4,
      'admin': 3,
      'pollster': 2,
      'media': 1,
      'public': 0,
    };
    
    const userLevel = roleHierarchy[userRole as keyof typeof roleHierarchy] || 0;
    const requiredLevel = roleHierarchy[requiredRole as keyof typeof roleHierarchy] || 0;
    
    return userLevel >= requiredLevel;
  };
  
  return {
    isSuperAdmin,
    isAdmin,
    isCountryAdmin,
    isPollster,
    isVerifiedPollster,
    isMedia,
    isPublic,
    userRole,
    hasRole
  };
};
